import api from 'api/config';

/**
 * User service for general (non-admin) user operations.
 */
export const userService = {
  /**
   * Search users by query and type, with optional role restriction.
   * @param {string} query - Search query string.
   * @param {string} type - Search type: 'all', 'email', 'name', 'role'.
   * @param {string} [role] - Optional role filter (admin, user, moderator, guest, ...).
   * @returns {Promise<Array>} List of matching users.
   */
  searchUsers: async (query, type = 'all', role) => {
    try {
      const params = { search: query, type };
      if (role) {
        params.role = role;
      }

      const response = await api.get('/users/search', { params });
      return response.data;
    } catch (error) {
      console.error('Error searching users:', error);
      throw error.response?.data || error.message;
    }
  },
};

export default userService;
